import * as React from 'react';
import * as SheetPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

const Sheet = SheetPrimitive.Root;
const SheetTrigger = SheetPrimitive.Trigger;
const SheetClose = SheetPrimitive.Close;
const SheetTitle = SheetPrimitive.Title;

function SheetContent({
  className,
  children,
  side = 'right',
  ...props
}: React.ComponentProps<typeof SheetPrimitive.Content> & {
  side?: 'left' | 'right';
}) {
  return (
    <SheetPrimitive.Portal>
      <SheetPrimitive.Overlay className="fixed inset-0 z-50 bg-black/76 transition-opacity data-[state=closed]:opacity-0 data-[state=open]:opacity-100" />
      <SheetPrimitive.Content
        className={cn(
          'fixed top-0 z-50 flex h-full w-full flex-col border-border bg-card shadow-2xl transition-transform duration-300',
          'sm:max-w-[420px]',
          side === 'right'
            ? 'right-0 border-l data-[state=closed]:translate-x-full data-[state=open]:translate-x-0'
            : 'left-0 border-r data-[state=closed]:-translate-x-full data-[state=open]:translate-x-0',
          className,
        )}
        {...props}
      >
        {children}
        <SheetPrimitive.Close
          className="absolute top-4 right-4 grid size-9 place-items-center border border-border text-lg leading-none transition-colors hover:border-primary hover:text-primary"
          aria-label="Close cart"
        >
          <X className="size-4" />
        </SheetPrimitive.Close>
      </SheetPrimitive.Content>
    </SheetPrimitive.Portal>
  );
}

export { Sheet, SheetClose, SheetContent, SheetTitle, SheetTrigger };
